/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { ModalController } from '@ionic/angular';
import { Component, Input } from '@angular/core';
import { BulletItemModel } from '@core/models';

@Component({
  selector: 'app-modal-tooltip',
  templateUrl: './modal-tooltip.component.html',
  styleUrls: ['./modal-tooltip.component.scss']
})
export class ModalTooltipComponent {
  @Input() title: string;

  @Input() description: string;

  @Input() bullets: BulletItemModel[];

  constructor(private modalController: ModalController) {}

  async close(): Promise<void> {
    await this.modalController.dismiss();
  }
}
